import React from 'react'
import { Oval } from 'react-loader-spinner'
import './loaderStyle.css';


const CircleLoade = () => {
    return (
        <div className="loader">
            <Oval
                height={100}
                width={100}
                color="#0077c0"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#0077c0"
                strokeWidth={2}
                strokeWidthSecondary={2}
            />
        </div>
    )
}

export default CircleLoade